const isClickOnHead = (event) => {
  if (event.target.id !== 'validateScrappedWagon') {
    const isActive = !!event.currentTarget.className.match('active')
    return !isActive
  }
}

const scrollOnTop = (offset) => {
  document.body.scrollTop = offset
}

/* @ngInject */
const scrollOnClick = (
  $timeout
) => {
  return {
    restrict: 'A',
    scope: {

    },
    link: (scope, element, attrs, ctrl) => {
      element.on('click', (event) => {
        if (isClickOnHead(event)) {
          $timeout(() => {
            scrollOnTop(element.offset().top - 10)
          })
        }
      })

      scope.$on('$destroy', () => { element.off() })
    },
  }
}

export default scrollOnClick



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/scrollOnClick.directive.js